<template>
    <div class="content">
        <div class="tab-container">
            <p class="title">已選擇的檔案及雜湊值</p>
            <button class="btn-secondary-blue mb-4" v-on:click="handleUploadButtonClick()">新增存證檔案</button>
            <input type="file" ref="input" multiple v-on:change="onFileChange" style="display:none" />
            <b-table class="upload_table w-100" :items="items" :fields="fields" :sort-by.sync="sortBy" label-sort-asc="" label-sort-desc="" label-sort-clear="" :sort-desc.sync="sortDesc" sticky-header hover responsive="sm">
                <template #cell(delete_button)="data">
                    <b-icon icon="x-circle-fill" variant="secondary" @click="handleDelete(data.index)" aria-hidden="true">
                    </b-icon>
                </template>
            </b-table>
        </div>
        <div class="footer">
            <button @click="handleUpload()" class="btn-primary-sm">存證至區塊鏈</button>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
export default {
    name: "UploadFilePage",
    props: {
        items: Array,
        handleDelete: Function,
        setLoading: Function,
        setFinished: Function,
        onFileChange: Function,
        setProgress: Function
    },
    methods: {
        handleUploadButtonClick() {
            this.$refs.input.click();
        },
        async handleUpload() {
            this.setLoading(true);
            const username = sessionStorage.getItem('username');
            const organs = sessionStorage.getItem('organs');
            for (let i = 0; i < this.items.length; i++) {
                
                let item = this.items[i];
                let response = await axios.post(`${process.env.VUE_APP_BACKEND_API_URL}/upload_file`, {
                    hash: item.hash,
                    file_name: item.fileName,
                    user: {
                        name: username,
                        company: organs
                    }
                });
                let percentage = (100 / this.items.length - 1);
                this.setProgress(percentage.toFixed(2));
                console.log(response.data);
            }
            this.setFinished(true);
            this.setProgress(100);
        }
    },
    data() {
        return {
            sortBy: 'index',
            sortDesc: false,
            fields: [{
                    key: "index",
                    sortable: true,
                    label: "項目",
                    thClass: "color-white border-table-row-primary",
                    tdClass: 'border-table-row-primary'
                },
                {
                    key: "fileName",
                    sortable: true,
                    label: "檔案名稱",
                    thClass: "color-white border-table-row-primary",
                    tdClass: 'border-table-row-primary'
                },
                {
                    key: "hash",
                    sortable: false,
                    label: "雜湊值",
                    thClass: "color-white border-table-row-primary",
                    tdClass: 'border-table-row-primary'
                },
                {
                    key: "delete_button",
                    sortable: false,
                    label: "",
                    thClass: "color-white border-table-row-primary",
                    tdClass: 'border-table-row-primary',
                    class: 'text-center'
                },
            ],
        };
    },
};
</script>